import { SET_MESSAGE, CLEAR_MESSAGE } from "../actions/dialogActions";

const initialState = {
  dialog: {},
}

function errorReducer(state = initialState, action) {
  switch (action.type) {
  case SET_MESSAGE:
    return {
      ...state,
      dialog: {
        title: action.payload.title,
        message: action.payload.message,
        type: action.payload.type,
        show: true,
      }
    }
  case CLEAR_MESSAGE:
    return {
      ...state,
      dialog: {}
    }
  default:
    return state;
  }
}

export default errorReducer;